 import React, { useEffect, useState } from "react";
import {
  numberWithCommas,
  dateForHumans,
  timeAmPm,
} from "../../utils";
import { Breadcrumb, Descriptions, Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import StatementTable from "./statement/StatementTable";
import EmtyCard from "../../components/EmtyCard";
import Topup from "./Topup";
import { setRefetch, setRefetchKey } from "../../features/global/globalSlice";
import WalletUsers from "./wallet-users/WalletUsers";

function MyWalletView() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { walletObj } = useSelector((state) => state.obj);

  // computed default key: if walletObj loaded choose based on type, otherwise default to "1"
  const computedDefaultKey =
    walletObj && Object.keys(walletObj).length
      ? walletObj.walType === "COLLECTION"
        ? "1"
        : "2"
      : "1";

  // controlled active key state — start with computedDefaultKey (safe) and update when walletObj becomes available
  const [active, setActive] = useState(computedDefaultKey);
 
  const items = [
    {
      key: "1",
      label: "Actual Balance",
      children: <div>{numberWithCommas(walletObj?.walActualBalance)}</div>,
    },
    {
      key: "4",
      label: "Available Balance",
      children: <div>{numberWithCommas(walletObj?.walAvailableBalance)}</div>,
    },
    {
      key: "7",
      label: "Code",
      children: walletObj?.walCode,
    },
    {
      key: "8",
      label: "Created At",
      children: <div>{dateForHumans(walletObj?.walCreatedAt)}</div>,
    },
    {
      key: "9",
      label: "Created Date",
      children: <div>{dateForHumans(walletObj?.walCreatedDate)}</div>,
    },
    {
      key: "10",
      label: "Created Time",
      children: <div>{timeAmPm(walletObj?.walCreatedTime)}</div>,
    },
    {
      key: "11",
      label: "Currency",
      children: walletObj?.walCurrency,
    },
    {
      key: "12",
      label: "Description",
      children: walletObj?.walDesc,
    },
    {
      key: "13",
      label: "Mpesa Number",
      children: walletObj?.walMpesaNumber,
    },
    {
      key: "14",
      label: "Wallet No",
      children: walletObj?.walNo,
    },
    {
      key: "15",
      label: "Status",
      children: walletObj?.walStatus,
    },
    {
      key: "16",
      label: "Type",
      children: walletObj?.walType,
    },
    {
      key: "17",
      label: "Updated Time",
      children: <div>{timeAmPm(walletObj?.walUpdatedTime)}</div>,
    },
  ];

 
  useEffect(() => {
    if (walletObj && Object.keys(walletObj)?.length) {
      const initialKey = walletObj?.walType === "COLLECTION" ? "1" : "2"; 
      if (initialKey !== active) {
        setActive(initialKey);
      } 
      dispatch(setRefetch());
      dispatch(setRefetchKey(Number(initialKey))); 
    } 
  }, [walletObj, dispatch]);
 
  function refetching(activeKey) { 
    setActive(activeKey); 
    dispatch(setRefetch()); 
    dispatch(setRefetchKey(Number(activeKey))); 
  }

  const tabConfigurations = [
    ...(walletObj?.walType === "COLLECTION"
      ? [
          {
            label: (
              <span className="flex items-center">
                <span className=" ">Top Up</span>
              </span>
            ),
            key: "1",
            children: <Topup setactive={setActive} />,
          },
        ]
      : []),
    {
      label: (
        <span className="flex items-center">
          <span className=" ">Statement</span>
        </span>
      ),
      key: "2",
      children: <StatementTable />,
    },
    {
      label: (
        <span className="flex items-center">
          <span className=" ">Wallet Users</span>
        </span>
      ),
      key: "3",
      children: <WalletUsers setactive={setActive} />,
    },
  ];

  return (
    <div className="flex flex-col w-full h-full overflow-y-scroll">
      <div className=" font-dmSans text-[18px] mt-[1.25rem]">
        <Breadcrumb
          items={[
            {
              title: (
                <span
                  className="font-dmSans cursor-pointer "
                  onClick={() => navigate(-1)}
                >
                  My Wallets
                </span>
              ),
            },
            {
              title: (
                <span className="text-lighGold font-dmSans !text-[16px]">
                  Wallet Details
                </span>
              ),
            },
          ]}
        />
      </div>

      {Object?.keys(walletObj)?.length > 0 ? (
        <div className="gap-[1.25rem] w-full mt-[1.25rem] !bg-[#F2F4F7] white_card">
          <Descriptions
            column={{
              xs: 1,
              sm: 2,
              md: 2,
              lg: 3,
              xl: 3,
              xxl: 3,
            }}
            colon={false}
            title="Wallet Details"
            items={items}
          />
        </div>
      ) : (
        <EmtyCard title="No main Wallet data available" />
      )}

      <div className="mt-[1.25rem] lg:px-10 px-3">
        <Tabs 
          defaultActiveKey={computedDefaultKey}
          activeKey={active || computedDefaultKey}
          items={tabConfigurations}
          onChange={refetching}
          className="activity-tab-wrap activity-tab activity-bar"
        />
      </div>
    </div>
  );
}

export default MyWalletView;
